import { useState } from 'react';
import { useRetryBilling as useRetryBillingMutation } from '../../../domain/PermanentJobs';

type TPaymentResultState = 'idle' | 'success' | 'failed';

export const useRetryBillingPayment = () => {
  const [paymentResultState, setPaymentResultState] = useState<TPaymentResultState>('idle');
  const [failedPostingIds, setFailedPostingIds] = useState<string[]>([]);

  const { mutateAsync: retryBilling, isPending: isProcessing } = useRetryBillingMutation();

  const handleRetryBilling = async () => {
    if (isProcessing) return;

    try {
      const response = await retryBilling();

      const failedResults = response.filter((result) => !result.success);
      const hasAnyFailure = failedResults.length > 0;

      if (hasAnyFailure) {
        const failedIds = failedResults.map((result) => result.postingId);
        setFailedPostingIds(failedIds);
        setPaymentResultState('failed');
      } else {
        setFailedPostingIds([]);
        setPaymentResultState('success');
      }

      return { success: !hasAnyFailure };
    } catch (error) {
      console.error('Payment error:', error);
      setFailedPostingIds([]);
      setPaymentResultState('failed');
      return { success: false };
    }
  };

  const resetPaymentState = () => {
    setPaymentResultState('idle');
    setFailedPostingIds([]);
  };

  return {
    paymentResultState,
    isProcessing,
    failedPostingIds,
    handleRetryBilling,
    resetPaymentState,
  };
};
